import * as React from 'react';
import {Svg, Path, Circle, G, Defs} from 'react-native-svg';

const EmptyFeed = props => {
  return (
    <Svg
      width={161}
      height={193}
      viewBox="0 0 161 193"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path d="M82 131l-63 31 63 31 63-31-63-31z" fill="#B1BAC7" />
      <Path d="M19 110.597L82 80v51.403L19 162v-51.403z" fill="#E0E4ED" />
      <Path
        d="M145 110.597L82 80v51.403L145 162v-51.403zM82 141.597L19 111v51.403L82 193v-51.403z"
        fill="#C3CCD9"
      />
      <G filter="url(#filter0_d_1811_21793)">
        <Path
          d="M82 141.508L18.588 111 5 128.492 68.412 159 82 141.508z"
          fill="#fff"
        />
      </G>
      <Path d="M82 141.597L145 111v51.403L82 193v-51.403z" fill="#E0E4ED" />
      <G filter="url(#filter1_d_1811_21793)">
        <Path
          d="M82 141.508L144.588 111 158 128.492 95.412 159 82 141.508z"
          fill="#fff"
        />
      </G>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M88.751 50.199c-8.613 6.898-21.221 6.355-29.206-1.63-8.567-8.566-8.567-22.456 0-31.024 8.568-8.567 22.458-8.567 31.025 0 7.984 7.985 8.527 20.593 1.629 29.206l16.755 16.756a2.437 2.437 0 11-3.447 3.447L88.751 50.2zm-25.758-5.076c-6.664-6.664-6.664-17.467 0-24.13 6.663-6.664 17.466-6.664 24.13 0 6.658 6.658 6.663 17.45.014 24.115l-.014.015-.015.014c-6.665 6.649-17.457 6.644-24.115-.014z"
        fill="#C3CCD9"
      />
      <Circle cx={5.5} cy={98.5} r={3.5} stroke="#4499D2" strokeWidth={2} />
      <Circle cx={105.5} cy={91.5} r={3.5} stroke="#4499D2" strokeWidth={2} />
      <Circle cx={139.5} cy={51.5} r={3.5} stroke="#4499D2" strokeWidth={2} />
      <Circle cx={73.5} cy={123.5} r={1.5} stroke="#4499D2" strokeWidth={2} />
      <Circle cx={139.5} cy={75.5} r={1.5} stroke="#4499D2" strokeWidth={2} />
      <Circle cx={12.5} cy={79.5} r={1.5} stroke="#4499D2" strokeWidth={2} />
      <Path
        d="M85.635 30.328a5.65 5.65 0 01-1.912 1.384 5.736 5.736 0 01-4.641 0 5.65 5.65 0 01-1.912-1.384 1.394 1.394 0 01-.363-1.01 1.381 1.381 0 01.47-.967 1.428 1.428 0 011.03-.348 1.442 1.442 0 01.979.47c.267.293.593.526.958.686a2.886 2.886 0 003.275-.685 1.422 1.422 0 01.979-.471 1.443 1.443 0 011.03.348 1.401 1.401 0 01.47.967 1.378 1.378 0 01-.363 1.01zm-12.805 0a1.394 1.394 0 00.363-1.01 1.381 1.381 0 00-.47-.967 1.428 1.428 0 00-1.03-.348 1.442 1.442 0 00-.979.47 2.844 2.844 0 01-.958.686 2.886 2.886 0 01-3.275-.685 1.422 1.422 0 00-.979-.471 1.443 1.443 0 00-1.03.348 1.401 1.401 0 00-.47.967 1.378 1.378 0 00.363 1.01 5.65 5.65 0 001.912 1.384 5.736 5.736 0 004.641 0 5.65 5.65 0 001.912-1.384zm7.683 9.097A10.132 10.132 0 0075 37.797c-1.96 0-3.877.566-5.513 1.628a1.397 1.397 0 00-.002 2.332 1.434 1.434 0 001.07.218c.183-.035.358-.105.515-.206A7.162 7.162 0 0175 40.597c1.4 0 2.767.408 3.93 1.172.317.2.702.27 1.07.195.37-.075.694-.29.904-.598.206-.31.28-.686.207-1.049a1.416 1.416 0 00-.598-.892z"
        fill="#C3CCD9"
      />
      <Defs></Defs>
    </Svg>
  );
};

export default EmptyFeed;
